export const projects = [
  {
    img: "https://zostelclone.netlify.app/static/media/landingpage4.a34068621afd59c4309667a719afbda0.svg",
    title: "Clone of Zostel",
    des: "Zostel is one of the largest and oldest networks of hostels and homes in India. It has a presence in 44 cities in India and Nepal.",
    demo: "",
    live: "https://zostelclone.netlify.app/",
    gitHub: "https://github.com/Aman974/zostel",
    technologies: ["React", "Redux", "Node", "Express","Mongodb"],
  },
  {
    img: "https://bl-i.thgim.com/public/companies/mdd8qr/article26502020.ece/alternates/LANDSCAPE_1200/bl12-01-paytm-mall",
    title: "Clone of Paytm Mall",
    des: "Paytm is an Indian multinational technology company that specializes in digital payment system, e-commerce and financial services, based in Noida. In February 2017, Paytm launched its Paytm Mall app, which allows consumers to shop from 1.4 lakh registered sellers.[78] Paytm Mall is a B2C model inspired by China's largest B2C retail platform TMall. Sellers have to pass through Paytm-certified warehouses and channels to ensure consumer trust. Paytm Mall has set up 17 fulfillment centres across India and partnered with more than 40 couriers.",
    demo: "",
    live: "https://paytm-mall-clone.netlify.app/",
    gitHub: "https://github.com/sinab06/PayTM-Mall-Clone",
    technologies: ["HTML", "CSS", "JavaScript","Node","Express", "MongoDB"],
  },
  {
    img: "https://miro.medium.com/v2/resize:fit:828/format:webp/1*fK2hpvDogB4TBStdqSJXnQ.png",
    title: "Clone of Tanishq",
    des: " Tanishq is a brand of Jewellery retail stores in India. The brand is the property of Titan Company, which is back by Tata Group and TIDCO. The Stores are located all over India. Tanishq has emerged as India’s fastest growing jewellery brand and is a name which signifies superior craftsmanship, exclusive designs and superlative product quality.",
    demo: "https://drive.google.com/file/d/1fyjOn_4EHX_9haKZkBuoDklBB1eBnSn9/view",
    live: "",
    gitHub: "https://github.com/heyrishabh13/Tanishq",
    technologies: ["HTML", "CSS", "JavaScript"],
  },
  {
    img: "https://i.ytimg.com/vi/iLsqNmR0uGI/mqdefault.jpg",
    title: "Clone of Fashionnova",
    des: "Fashion Nova is a US-based fast fashion retail company. The company operates online and has five brick-and-mortar locations. The company is known to use Instagram to gain >earned media for its clothing by interacting with users and generating publicity through a mix of models, celebrities, and other customers..",
    demo: "",
    live: "https://mehtab39.github.io/projectfashionnova/root/index.html",

    gitHub: "https://github.com/mehtab39/projectfashionnova",
    technologies: ["HTML", "CSS", "JavaScript"],
  },
];